import React from "react";

import { BulletList, BulletListType } from "@at/design-system-patterns";

import * as Styled from "../leasing-modal-shared-styles.styled";

export const HowLeasingWorksModal = () => {
  return (
    <Styled.Content>
      <Styled.Title>How leasing works with Auto Trader </Styled.Title>
      <Styled.Body>
        <p>
          New to leasing? No fear, we’ve got the important bits here for you.{" "}
        </p>
        <Styled.Subheading>
          It&apos;s like renting but for longer
        </Styled.Subheading>
        <p>
          The important thing to know about leasing is that you don’t own the
          vehicle. You simply ‘lease’ it from the lender and drive it for an
          agreed period of time (usually one to four years).
        </p>
        <Styled.Subheading>Pay monthly</Styled.Subheading>
        <p>
          You choose how much you want to pay upfront at the start of your lease
          term. The more you pay upfront, the lower your monthly payments will
          be.
        </p>
        <p>
          You then pay a series of equal monthly payments for the agreed length
          of your lease, a bit like a phone contract.
        </p>
        <Styled.Subheading>What to expect</Styled.Subheading>
        <p>Here’s what happens when you lease with Auto Trader:</p>
        <BulletList
          items={[
            "You choose your vehicle, how long you want it for, and how much you can pay upfront.",
            "We reach out to our panel of trusted funders to find you the best deal",
            "You apply for lease credit with us online. It’s important to know that a lease is a credit agreement, so you will need a good credit history.",
            "We’ll send you the documents to sign, and help you get your monthly payments set up.",
            "You book your free delivery slot* and enjoy driving your brand new vehicle.",
            "At the end of your term we’ll collect the vehicle from your home address.",
          ]}
          listType={BulletListType.ORDERED}
        />
        <Styled.HighlightedPoint as="p">
          *Delivery is free, however we can only deliver to mainland UK,
          excluding Northern Ireland.
        </Styled.HighlightedPoint>
        Want to know more?{" "}
        <a
          href="https://www.autotrader.co.uk/terms-and-conditions/vanarama"
          target="_blank"
          rel="noreferrer"
        >
          Read our full Terms and Conditions for all the legal bits.
        </a>
      </Styled.Body>
    </Styled.Content>
  );
};
